import { createContext, useContext, useMemo } from 'react'

import axios, { Axios } from 'axios'

import { useOktaAuth } from '@lib/okta-web'

const AxiosContext = createContext<Axios>(axios)

export interface ApiConfig {
  baseUri: string
}

export interface ApiAxiosProviderProps {
  children: any
  config: ApiConfig
}

export const ApiAxiosProvider = ({
  children,
  config,
}: ApiAxiosProviderProps) => {
  const auth = useOktaAuth()

  const apiAxiosInstance = useMemo(() => {
    const instance = axios.create({
      baseURL: config.baseUri,
    })

    instance.interceptors.request.use(async (config) => {
      await auth.oktaAuth.getOrRenewAccessToken()
      const accessToken: string = auth.authState?.accessToken?.accessToken ?? ''

      config.headers.set('Authorization', `Bearer ${accessToken}`)
      config.validateStatus ??= (status) => status >= 200 && status < 300
      return config
    })

    return instance
  }, [auth.authState?.accessToken?.accessToken, auth.oktaAuth, config.baseUri])

  return (
    <AxiosContext.Provider value={apiAxiosInstance}>
      {children}
    </AxiosContext.Provider>
  )
}

export const useApiAxios = () => {
  return useContext(AxiosContext)
}
